/* eslint-disable */
import { useState, useEffect, useMemo } from "react";
import { orderBy } from "lodash";
import { yearToCropYearShort, OLAPTransformerResult } from "../../../shared";
import Highcharts from "highcharts";
import { TableProps } from "../../../components/Table";
import { CATEGORIES_AXIS, SERIES_AXIS } from "../constants";

export function useChart2(data: OLAPTransformerResult | null, orderedCountriesIds: number[] | null): TableProps | undefined {
  const [state, setState] = useState<TableProps | undefined>();
  const colKey = `${CATEGORIES_AXIS}.name`;

  const categories = useMemo(
    () => orderBy(data?.columns, c => orderedCountriesIds?.indexOf(Number(c.selection[CATEGORIES_AXIS]))).map((x) => `${x.headers.find((h) => h.id === colKey)?.name}`) || [],
    [data, orderedCountriesIds],
  ); 

  useEffect(() => {
    if (data) {
      const rows = data?.rows.map((x) => {
        const period = x.attributes[`${SERIES_AXIS}.name`]
        const records = {
          Period: yearToCropYearShort(period) || "",
          rawPeriod: period
        };
        for (const point of orderBy(x.points, p => orderedCountriesIds?.indexOf(p.column.selection[CATEGORIES_AXIS] as number))) {
          const col = point.attributes ? point.attributes[colKey] : '';
          records[col] = Highcharts.numberFormat(point.value || 0, 1);
        }
        return records;
      });
      const result: TableProps = {
        columns: [{
          headerName: "Period",
          field: "Period",
          resizable: true,
          lockPosition: true,
        } as any]
        .concat(categories.map((x) => ({ 
          headerName: x, 
          field: x, 
          resizable: true, 
          initialSortIndex: categories.indexOf(x)  
        }))),
        rows,
      };

      setState(result);
    } else {
      setState(undefined);
    }
  }, [data, categories, orderedCountriesIds]);
  return state;
}
